import React from "react";
import type { Professional } from "../../../types";
import { Card } from "../../shared";
import { MonthPeriodPicker } from "./MonthPeriodPicker";
import { ReportsProfessionalAvatarSelect } from "./ReportsProfessionalAvatarSelect";

export interface CarsThroughputFiltersCardProps {
  month: number;
  year: number;
  onMonthYearChange: (month: number, year: number) => void;
  disabled?: boolean;
  professionals: Professional[];
  selectedProfessionalId: number | null;
  onSelectProfessional?: (id: number | null) => void;
  loadingProfessionals?: boolean;
  /** When true, shows only the logged-in professional (no team filter). */
  professionalView?: boolean;
  /** When true, hides the "Todos" option (single-professional selection required). */
  hideAllOption?: boolean;
}

export const CarsThroughputFiltersCard: React.FC<CarsThroughputFiltersCardProps> = ({
  month,
  year,
  onMonthYearChange,
  disabled = false,
  professionals,
  selectedProfessionalId,
  onSelectProfessional,
  loadingProfessionals = false,
  professionalView = false,
  hideAllOption = false,
}) => {
  const showProfessionalFilter =
    professionals.length > 0 && (professionalView || onSelectProfessional != null);

  return (
    <Card className="p-4 sm:p-6 border border-gray-100 shadow-sm">
      <div
        className={`flex flex-col gap-5 ${
          showProfessionalFilter ? "lg:flex-row lg:items-start lg:gap-8" : ""
        }`}
      >
        <div className={showProfessionalFilter ? "flex-1 min-w-0" : "w-full max-w-md"}>
          <p className="text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wide mb-2">
            Período
          </p>
          <MonthPeriodPicker
            month={month}
            year={year}
            onChange={onMonthYearChange}
            disabled={disabled}
            className="w-full max-w-md"
          />
        </div>

        {showProfessionalFilter && (
          <div className="flex-1 min-w-0 lg:border-l lg:border-gray-100 lg:dark:border-slate-700 lg:pl-8">
            <ReportsProfessionalAvatarSelect
              professionals={professionals}
              selectedProfessionalId={selectedProfessionalId}
              onSelectProfessional={onSelectProfessional ?? (() => {})}
              loading={loadingProfessionals}
              disabled={disabled || professionalView}
              hideAllOption={professionalView || hideAllOption}
              readOnly={professionalView}
            />
          </div>
        )}
      </div>
    </Card>
  );
};
